module.exports = __webpack_public_path__ + "assets/loader.gif";


//////////////////
// WEBPACK FOOTER
// ./libs/images/loader.gif
// module id = 352
// module chunks = 0